// import React from 'react';
import {
  Linking,
  Platform,
} from 'react-native';
import infraConfig from '../config.json';
import InAppBrowser from '../browser'; // eslint-disable-line import/named


const urlOpener = async (url, redirectUrl) => {
  console.log('urlOpener');
  console.log(url);
  console.log(redirectUrl);

  if (await InAppBrowser.isAvailable()) {
    console.log('InAppBrowser is available');
    const authResponse = await InAppBrowser.openAuth(url, redirectUrl, {
      showTitle: false,
      enableUrlBarHiding: true,
      enableDefaultShare: false,
      ephemeralWebSession: false,
    });
    const { type: result, url: newUrl } = authResponse;

    console.log('result');
    console.log(result);
    console.log(newUrl);

    if (result === 'success') {
      console.log('InAppBrowser suceeded');
      Linking.openURL(newUrl)
        .then(() => {
          console.log('openURL() succeeded 2');
        })
        .catch(() => {
          console.log('openURL() failed 2');
        });
    }
  } else {
    console.log('InAppBrowser is NOT available');
    Linking.openURL(url)
      .then(() => {
        console.log('openURL() succeeded');
      })
      .catch(() => {
        console.log('openURL() failed');
      });
  }
};

export default {
  Auth: {
    Cognito: {
      // REQUIRED - Amazon Cognito Identity Pool ID 
      identityPoolId: infraConfig.identityPool,
      // OPTIONAL - Allow guest access to the identity pool
      allowGuestAccess: true,

      // REQUIRED - Amazon Cognito Region
      region: infraConfig.region,
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: infraConfig.usersPool,
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: infraConfig.usersPoolClient,
      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,
      // // OPTIONAL - Configuration for cookie storage
      cookieStorage: {
        // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        // domain: '.aionrails.com',
        domain: `.${infraConfig.domainName}`,
        // OPTIONAL - Cookie path
        path: '/',
        // OPTIONAL - Cookie expiration in days
        expires: 365,
        // OPTIONAL - Cookie secure flag
        secure: true,
      },
      loginWith: {
        oauth: {
          // domain: `${window.location.host}`,
          domain: `login.${infraConfig.domainName}`,
          // The below are the scopes to request from Congnito.
          // Not to be confused with the scopes to request from Google (those are set through the Cognito admin UI).
          scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: Platform.OS === 'web' ? [`https://${window.location.host}/auth/google`] : ['aionrails://auth/google'],
          redirectSignOut: Platform.OS === 'web' ? [`https://${window.location.host}/logout`] : ['aionrails://logout'],
          responseType: 'code',
          providers: ['Google'],
          urlOpener: Platform.OS !== 'web' ? urlOpener : undefined,
        },
        username: false,
        email: true,
        phone: false,
      },
      userAttributes: {
        email: {
          required: true,
        },
      },
      signUpVerificationMethod: 'code',
      federationTarget: 'COGNITO_USER_POOLS',
    },
  },
  // aws_appsync_region: infraConfig.region,
  // aws_project_region: infraConfig.region,
  // API: {
  //   endpoints: [
  //     // {
  //     //   name: 'prod',
  //     //   endpoint: 'https://ak1doksp20.execute-api.us-west-2.amazonaws.com/prod',
  //     // },
  //     {
  //       name: 'images',
  //       endpoint: infraConfig.imagesApiUrl,
  //     },
  //     {
  //       name: 'audio',
  //       endpoint: infraConfig.audioApiUrl,
  //     },
  //   ],
  // },
  // // Storage: {
  // //   AWSS3: {
  // //     bucket: 'gmu-b64intake',
  // //     region: 'us-west-2',
  // //   },
  // // },
};
